// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_10u7t","smallLinkTypography":"_15bqy","titleTypography":"_3i36u","cardTitleTypography":"_213-f","nameCell":"_3q4tf","truncate":"uwf3U","base":"_3g2_F","subHeadingStyle":"_3_5Ua","noBeneficiary":"ViV_M","buttonAction":"ZK_mj","buttonLeft":"bEgjt","buttonRight":"_3sw0O","buttonBorder":"_2hnNe","buttonContainer":"_3dgNt","flexDirection":"_3648q"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PersonalInfo/components/PartnerChildren/PartnerChildrenList.scss
// module id = 2579
// module chunks = 0